export const getCropSeasonMinStartDateEpoch = seasons =>
  seasons
    ?.map(season => season?.startDateEpoch)
    .reduce((min, current) => (!min || current < min ? current : min), null);

export const getCropSeasonMaxEndDateEpoch = seasons =>
  seasons
    ?.map(season => season?.endDateEpoch)
    .reduce((max, current) => (!max || current > max ? current : max), null);
